module.exports = __webpack_public_path__ + "static/media/Whitney-Semibold.6897a1fa.otf";